import { Radio, RadioGroup } from 'react-radio-group';

const labelStyle = {
  cursor: 'pointer',
  padding: 0,
  marginTop: 2,
  marginBottom: 0,
};
const radioStyle = {
  cursor: 'pointer',
  marginLeft: '10px',
};

export default function LayerToggler({ onChange, selectedLayer }) {
  return (
    <RadioGroup
      style={{ display: 'flex', alignItems: 'center' }}
      selectedValue={selectedLayer}
      className="mt-3"
      name="layer-radio"
      onChange={onChange}
    >
      <Radio style={radioStyle} id="bg-radio" value="BlockGroups" />
      <label htmlFor="bg-radio" className="ml-2" style={labelStyle}>
        Block Groups
      </label>
      <Radio style={radioStyle} id="tract-radio" value="Tracts" />
      <label htmlFor="tract-radio" className="ml-2" style={labelStyle}>
        Tracts
      </label>
    </RadioGroup>
  );
}
